import { useQuery } from '@tanstack/react-query';

import { getIssuers } from '@arrived/api_v2';
import { Issuer } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { issuersQueryKey } from './issuers.keys';

export function useGetIssuersQuery(options?: UseQueryOptions<Issuer[]>): UseQueryResult<Issuer[]> {
  return useQuery(issuersQueryKey, async () => getIssuers(), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
